import React from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { StyledValue, StyledVcLabelNormal } from '../../GoogleMap/styles';
import { getVCLabel, getValueLabel } from '../../MapPopup/utils/variabilityIndexHelper';
import { getTooltipLablesForVC } from '../../MapPopup/utils/vcCommon';
import {
  VariabilityIndexIconMultifield,
  HeterogeneityIndexIconMultifield,
  ConsistencyIndexIconMultifield,
  FieldAreaIconMultifield,
  infoIcon
} from '../../../common/Icons';

export const VCIboxContent = (props) => {
  const { t } = useTranslation();
  const { fieldInfo, fieldArea } = props;

  const isVariabilityDataAvailable = Object.keys(fieldInfo.index).length > 0;

  return (
    <div className='vci-box' data-testid='vci-box'>
      <div className='cardContent'>
        <div className='title'>
          <VariabilityIndexIconMultifield />
          <span>{t('Variability Index')}</span>
          <span className='info-icon'>
            <Tooltip
              placement='top'
              title={getTooltipLablesForVC(t)['VCIndex']}
              color={'#232630'}
              overlayInnerStyle={{
                padding: '6px 10px 6px 10px',
                fontSize: '14px',
                lineHeight: '20px',
                borderRadius: '4px',
                width: '358px'
              }}
              overlayStyle={{
                paddingBottom: '4px'
              }}
            >
              {infoIcon}
            </Tooltip>
          </span>
        </div>
        <div className='index_value_div'>
          <>
            <span className='vc-value'>{getVCLabel(fieldInfo.index.vxc, t)}</span>
            <StyledValue>
              {isVariabilityDataAvailable ? Number(fieldInfo.index.vxc).toFixed(2) : 'N/A'}
            </StyledValue>
          </>
        </div>
      </div>

      <div className='cardContent'>
        <div className='title'>
          <HeterogeneityIndexIconMultifield />
          <span>{t('Heterogenity Index')}</span>
          <span className='info-icon'>
            <Tooltip
              placement='top'
              title={getTooltipLablesForVC(t)['Variability']}
              color={'#232630'}
              overlayInnerStyle={{
                padding: '6px 10px 6px 10px',
                fontSize: '14px',
                lineHeight: '20px',
                borderRadius: '4px',
                width: '358px'
              }}
              overlayStyle={{
                paddingBottom: '4px'
              }}
            >
              {infoIcon}
            </Tooltip>
          </span>
        </div>
        <div className='index_value_div'>
          <StyledVcLabelNormal className='indexValue'>
            {t(getValueLabel(fieldInfo.index.variability, t))}
          </StyledVcLabelNormal>
          <StyledValue>
            {isVariabilityDataAvailable ? Number(fieldInfo.index.variability).toFixed(2) : 'N/A'}
          </StyledValue>
        </div>
      </div>

      <div className='cardContent'>
        <div className='title'>
          <ConsistencyIndexIconMultifield />
          <span>{t('Consistency Index')}</span>
          <span className='info-icon'>
            <Tooltip
              placement='top'
              title={getTooltipLablesForVC(t)['Consistency']}
              color={'#232630'}
              overlayInnerStyle={{
                padding: '6px 10px 6px 10px',
                fontSize: '14px',
                lineHeight: '20px',
                borderRadius: '4px',
                width: '358px'
              }}
              overlayStyle={{
                paddingBottom: '4px'
              }}
            >
              {infoIcon}
            </Tooltip>
          </span>
        </div>
        <div className='index_value_div'>
          <StyledVcLabelNormal className='indexValue'>
            {t(getValueLabel(fieldInfo.index.consistency, t))}
          </StyledVcLabelNormal>
          <StyledValue>
            {isVariabilityDataAvailable ? Number(fieldInfo.index.consistency).toFixed(2) : 'N/A'}
          </StyledValue>
        </div>
      </div>

      <div className='cardContent'>
        <div className='title'>
          <FieldAreaIconMultifield />
          <span>{t('Field Area')}</span>
        </div>
        <div className='index_value_div'>
          <StyledValue>{Number(fieldArea)?.toFixed(2)} ha</StyledValue>
        </div>
      </div>
    </div>
  );
};

VCIboxContent.propTypes = {
  fieldInfo: PropTypes.any,
  fieldArea: PropTypes.any
};
